
import Divisor from './Divisor';
import TituloNegrito from './TituloNegrito';

import Image from 'react-bootstrap/Image';

import header from '../images/duroc-header.png'

import constantes from '../helpers/constanteHelper';
import { retornarTexto } from '../helpers/textoHelper'

function DetalhesCertificacaoDuroc({ resolucaoMobile, idioma }) {
    return (
        <>
            <Divisor />
            <TituloNegrito texto={retornarTexto(idioma, 'certificacaoDuroc')} />
            <Image style={{ height: '400px', objectFit: 'contain', padding: '20px' }} src={header} alt='logo' fluid />
            <span className='mt-4 mb-5' style={{ width: resolucaoMobile ? '90vw' : '70vw', color: constantes.CORES.BRANCO_PADRAO, fontSize: resolucaoMobile ? '16px' : '20px', textAlign: resolucaoMobile ? 'justify' : 'center', whiteSpace: 'pre-line' }}>
            {retornarTexto(idioma, 'descricaoCertificacaoDurocParte1')}<br /><br />
            {retornarTexto(idioma, 'descricaoCertificacaoDurocParte2')}
            </span>
        </>
    );
}
export default DetalhesCertificacaoDuroc;
